// extracted by mini-css-extract-plugin
export var actions = "_2i-0";
export var actionsContainer = "_2i-7";
export var border = "_2i-1";
export var childFullHeight = "_2i-f";
export var collapse = "_2i-2";
export var content = "_2i-a";
export var contentChild = "_2i-e";
export var fullscreen = "_2i-c";
export var hasLeftRadius = "_2i-k";
export var headerContainer = "_2i-3";
export var headerRow = "_2i-5";
export var hidePadding = "_2i-b";
export var navCollapsedGap = "_2i-l";
export var noScrollX = "_2i-m";
export var noScrollY = "_2i-n";
export var noTopPadding = "_2i-i";
export var optOutTopPadding = "_2i-d";
export var pageMain = "_2i-j";
export var pageOuter = "_2i-g";
export var pagePadding = "_2i-8";
export var pageScroll = "_2i-9";
export var profile = "_2i-o";
export var profileContainer = "_2i-p";
export var profileImage = "_2i-q";
export var profileMain = "_2i-r";
export var profileSubtitle = "_2i-t";
export var profileTitle = "_2i-s";
export var showLeftPadding = "_2i-h";
export var tabsPortalSlot = "_2i-6";
export var tabsWrapper = "_2i-4";
export var title = "_2i-u";